(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-image-width-text"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function () {
    $('.image-bar .playpause').fadeOut();

    $('.image-bar .video')
      .parent()
      .click(function () {
        if ($(this).children('.video').get(0).paused) {
          $(this).children('.video').get(0).play();
          $(this).children('.playpause').fadeOut();
        } else {
          $(this).children('.video').get(0).pause();
          $(this).children('.playpause').fadeIn();
        }
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hp-gg"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function() {
    $(".image-bar .playpause").fadeOut();

    $(".image-bar .video").parent().click(function () {
      if ($(this).children(".video").get(0).paused) {
        $(this).children(".video").get(0).play(); $(this).children(".playpause").fadeOut();
      } else {
        $(this).children(".video").get(0).pause();
        $(this).children(".playpause").fadeIn();
      }
    });
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hp-image-text"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function() {
    $(".image-bar .playpause").fadeOut();

    $(".image-bar .video").parent().click(function () {
      if ($(this).children(".video").get(0).paused) {
        $(this).children(".video").get(0).play(); $(this).children(".playpause").fadeOut();
      } else {
        $(this).children(".video").get(0).pause();
        $(this).children(".playpause").fadeIn();
      }
    });
  })

  } catch(e) { console.error(e); }
})();
})();
